/* Kick Frame: snel toevoegen vanaf een productkaart (knop "+ A3" op de foto). Voegt de A3-poster zonder lijst toe
   via /cart/add.js en opent daarna de bestaande winkelwagen-lade van kickframe.js (knop [data-cart-toggle]). */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function add(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-quick-add');
    var label = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = '…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      btn.textContent = '✓';
      var toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) toggle.click();
    }).catch(function () {
      window.location.href = btn.closest('a') ? btn.closest('a').href : root;
    }).then(function () {
      window.setTimeout(function () { btn.innerHTML = label; btn.removeAttribute('aria-busy'); }, 1600);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    add(btn);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest && e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    add(btn);
  }, true);
})();
